import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/mina-sidor/avtalsforfragningar")({
  beforeLoad: () => {
    throw redirect({ to: "/mina-sidor/forfragningar", statusCode: 301 });
  },
});
